import { EventBus } from "../../../eventbus";

export default {
  data() {
    return {
      user: this.$store.state.user,
      role: this.$store.state.role,
      roleName: null,
      company: this.$store.state.company,
      company_full: this.$store.state.company_full,
      show: false,
      more: false,
      showNotifications: false,
      showNotificationDot: false,
    };
  },
  watch: {
    showNotifications(newVal, oldVal) {
      if (newVal == true) {
        EventBus.$emit("notifications-checked");
        this.showNotificationDot = false;
      }
    },
  },
  created() {
    this.roleName = this.$store.state.role ? this.$store.state.role.name : "";

    EventBus.$on("login", (id) => {
      this.user = this.$store.state.user;
      this.show = false;
    });
    EventBus.$on("show-notification-dot", (callback) => {
      this.showNotificationDot = true;
    });
  },

  methods: {
    logout() {
      this.$store.state.user = null;
      this.user = null;
      this.$axios.defaults.params["key"] = null;
      localStorage.setItem(
        this.$store.state.company + "_" + "user",
        JSON.stringify(null)
      );
      this.$router.push("/" + this.$store.state.company);
      EventBus.$emit("login"); //Trust me this has te be here ;)
    },
    goTo(route) {
      this.more = false;
      this.$router.push(route);
      this.show = false;
    },
    toggleAdminMenu() {
      if (this.show) {
        this.show = false;
      }
    },
    toggleMoreMenu() {
      if (this.more) {
        this.more = false;
      }
    },
    hideAllMenus() {
      this.more = false;
      this.show = false;
      this.showNotifications = false;
    },
    getUsedPercentage() {
      // convert to MB
      let usedMb = this.company_full.usage * 1048576; // bytes to mb
      let totalMb = this.company_full.plan.size * 1048576; // bytes to mb
      let amount = (usedMb / totalMb) * 100;
      return amount < 1 ? 1 : amount;
    },
  },
};
